var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { DataSourceDto } from '../../../../shared/service-proxies/service-proxies';
import { DataSourceType } from '../shared/data-source-type-enum';
var CreateOrEditDataSourceModalComponent = /** @class */ (function (_super) {
    __extends(CreateOrEditDataSourceModalComponent, _super);
    function CreateOrEditDataSourceModalComponent(injector, modalElementRef, bsModalRef, dataSourceProxy) {
        var _this = _super.call(this, injector) || this;
        _this.modalElementRef = modalElementRef;
        _this.bsModalRef = bsModalRef;
        _this.dataSourceProxy = dataSourceProxy;
        _this.saving = false;
        _this.datasource = new DataSourceDto();
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(CreateOrEditDataSourceModalComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    CreateOrEditDataSourceModalComponent.prototype.ngOnInit = function () {
        $(this.displayName.nativeElement).focus();
        this.datasource = this.dataSourceCopy;
    };
    CreateOrEditDataSourceModalComponent.prototype.save = function () {
        var _this = this;
        var modalNativeElement = this.modalElementRef.nativeElement;
        abp.ui.setBusy(modalNativeElement);
        this.saving = true;
        this.datasource.dataSourceType = DataSourceType.FBox.valueOf();
        this.dataSourceProxy.saveDataSource(this.datasource).pipe(finalize(function () {
            _this.saving = false;
            abp.ui.clearBusy(modalNativeElement);
        })).subscribe(function (datasourceId) {
            _this.notify.info(_this.l('SavedSuccessfully'));
            abp.event.trigger('dataSource.rename');
            _this.close(false, datasourceId);
        });
    };
    CreateOrEditDataSourceModalComponent.prototype.close = function (isImport, dataSourceId) {
        this._onClosed.next({ isImport: isImport, dataSourceId: dataSourceId });
        this._onClosed.complete();
        this.saving = false;
        this.bsModalRef.hide();
    };
    CreateOrEditDataSourceModalComponent.prototype.saveAndImport = function () {
        var _this = this;
        var modalNativeElement = this.modalElementRef.nativeElement;
        abp.ui.setBusy(modalNativeElement);
        this.saving = true;
        this.datasource.dataSourceType = DataSourceType.FBox.valueOf();
        this.dataSourceProxy.saveDataSource(this.datasource).pipe(finalize(function () {
            _this.saving = false;
            abp.ui.clearBusy(modalNativeElement);
        })).subscribe(function (datasourceId) {
            _this.notify.info(_this.l('SavedSuccessfully'));
            _this.close(true, datasourceId);
        });
    };
    __decorate([
        ViewChild('displayName', { static: true })
    ], CreateOrEditDataSourceModalComponent.prototype, "displayName", void 0);
    CreateOrEditDataSourceModalComponent = __decorate([
        Component({
            selector: 'create-save-data-source-modal',
            template: "<div class=\"design-fe-modal-container\"> <div class=\"fe-modal-container\"> <form #saveForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> <span *ngIf=\"datasource.id\">{{lc(\"ModifyDataSource\")}}</span> <span *ngIf=\"!datasource.id\">{{lc(\"AddDataSource\")}}</span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"modal-body\"> <div class=\"variable-transverse clearfix\"> <div class=\"variable-title\"> <i class=\"star\">*</i> <span>{{lc(\"DataSourceName\")}}:</span> </div> <div class=\"variable-input\"> <input type=\"text\" name=\"displayName\" class=\"displayNameInput\" #displayName [(ngModel)]=\"datasource.displayName\" maxlength=\"20\" required> <validation-messages [formCtrl]=\"displayName\"></validation-messages> </div> </div> <div class=\"variable-transverse clearfix\" *ngIf=\"!datasource.id\"> <div class=\"variable-title\"> {{lc(\"DataSourceType\")}}: </div> <div class=\"variable-input\"> <button disabled>{{getFBoxAlias()}}</button> </div> </div> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!saveForm.form.valid || saving\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button class=\"fe-btn fe-btn-default fe-btn-save save-and-import\" [disabled]=\"!saveForm.form.valid || saving\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\" (click)=\"saveAndImport()\" *ngIf=\"!datasource.id\"> {{lc(\"SaveAndImport\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div>",
            styles: [".design-fe-modal-container{ .variable-transverse{ width: 100%; margin-bottom: 20px; .variable-title,.variable-input{ float: left; } .variable-title{ width: 30%; line-height: 30px; text-align: right; padding-right: 20px; .star{ color: red; margin-right: 5px; } } .variable-input{ width: 65%; input{ width: 100%; height: 30px; } button[disabled]{ border: 1px solid #C4C6CF; background-color: #F2F3F7; height: 30px; } } } .fe-modal-container .fe-modal-header{ border-bottom: 1px solid #f4f4f4; .fe-modal-header-title{ line-height: 50px; } } .modal-body{ padding-bottom: 0px; } .variable-transverse:last-child{ margin-bottom: 0px; } .fe-btn.fe-btn-default.fe-btn-save.save-and-import{ width: auto; padding: 0 10px; } }"]
        })
    ], CreateOrEditDataSourceModalComponent);
    return CreateOrEditDataSourceModalComponent;
}(ConfigureComponentBase));
export { CreateOrEditDataSourceModalComponent };
